<div class="main-outer company-list admin-customer-subscription">
    <app-header></app-header>
    <div class="municipality-accounts" [ngClass]="Menustatus ? 'show' : ''">
        <!-- <div class="common-add-button" (click) = "onAddIconClick(0)" (click)="onAddIconClick(0)">
            <a href="javascript:void(0);" class="plus-icon"><i
                class="ic plus-ic"></i></a>
        </div> -->

        <div class="municipality-accounts__sidebar doc-cabinet-menu-left">
            <h2 class="heading-secondery">Admin</h2>

            <ul class="dc-menu-list">
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/company">Customers</a>
                </li>
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/subscriptions" class="active">Subscriptions</a>
                </li>
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/batches" routerLinkActive="active">Batches</a>
                </li>
            </ul>

            <a href="javascript:void(0);" class="sidebar-menu" (click)="showMenu()">
                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 1.40476C0 1.07008 0.132951 0.749111 0.369604 0.512457C0.606258 0.275804 0.927229 0.142853 1.26191 0.142853H16.4048C16.7395 0.142853 17.0605 0.275804 17.2971 0.512457C17.5338 0.749111 17.6667 1.07008 17.6667 1.40476C17.6667 1.73944 17.5338 2.06041 17.2971 2.29706C17.0605 2.53372 16.7395 2.66667 16.4048 2.66667H1.26191C0.927229 2.66667 0.606258 2.53372 0.369604 2.29706C0.132951 2.06041 0 1.73944 0 1.40476Z"
                        fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M7.57144 7.7143C7.57144 7.37962 7.70439 7.05865 7.94105 6.822C8.1777 6.58534 8.49867 6.45239 8.83335 6.45239H16.4048C16.7395 6.45239 17.0604 6.58534 17.2971 6.822C17.5338 7.05865 17.6667 7.37962 17.6667 7.7143C17.6667 8.04898 17.5338 8.36995 17.2971 8.6066C17.0604 8.84326 16.7395 8.97621 16.4048 8.97621H8.83335C8.49867 8.97621 8.1777 8.84326 7.94105 8.6066C7.70439 8.36995 7.57144 8.04898 7.57144 7.7143Z"
                        fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 14.0238C0 13.6892 0.132951 13.3682 0.369604 13.1315C0.606258 12.8949 0.927229 12.7619 1.26191 12.7619H16.4048C16.7395 12.7619 17.0605 12.8949 17.2971 13.1315C17.5338 13.3682 17.6667 13.6892 17.6667 14.0238C17.6667 14.3585 17.5338 14.6795 17.2971 14.9161C17.0605 15.1528 16.7395 15.2857 16.4048 15.2857H1.26191C0.927229 15.2857 0.606258 15.1528 0.369604 14.9161C0.132951 14.6795 0 14.3585 0 14.0238Z"
                        fill="white" />
                </svg>
            </a>
        </div>


        <div class="container">

                <div class="subscription-page__content">

                    <ul class="breadcrumb">
                        <li class="breadcrumb__item">
                            <a href="javascript:void(0);" routerLink="/subscriptions">Subscriptions</a>
                        </li>
                        <li class="breadcrumb__item">
                            {{ customerName }}
                        </li>
                    </ul>

                    <div class="subscriptions-header">
                        <h1 class="customer-sum blue-txt">
                            <a  class="back-btns" href="javascript:void(0);"  routerLink="/subscriptions"><svg _ngcontent-snr-c14="" fill="none" height="15" viewBox="0 0 19 15" width="19" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-snr-c14="" d="M1 6.85L6.93744 1V4.25C17.0761 4.25 18.2457 10.5407 17.9641 14C17.5383 12.2547 17.3407 9.45 6.93744 9.45V12.7L1 6.85Z" stroke="#505050" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"></path></svg></a>
                            Subscription Management
                        </h1>

                        <!-- <a class="btn-primary add-buttons" href="javascript:void(0);"
                            (click)="openNewSubscriptionDialog()">
                            <svg class="svg-icon" fill="none" height="20" viewBox="0 0 20 20" width="20"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM10.625 5.625C10.625 5.45924 10.5592 5.30027 10.4419 5.18306C10.3247 5.06585 10.1658 5 10 5C9.83424 5 9.67527 5.06585 9.55806 5.18306C9.44085 5.30027 9.375 5.45924 9.375 5.625V9.375H5.625C5.45924 9.375 5.30027 9.44085 5.18306 9.55806C5.06585 9.67527 5 9.83424 5 10C5 10.1658 5.06585 10.3247 5.18306 10.4419C5.30027 10.5592 5.45924 10.625 5.625 10.625H9.375V14.375C9.375 14.5408 9.44085 14.6997 9.55806 14.8169C9.67527 14.9342 9.83424 15 10 15C10.1658 15 10.3247 14.9342 10.4419 14.8169C10.5592 14.6997 10.625 14.5408 10.625 14.375V10.625H14.375C14.5408 10.625 14.6997 10.5592 14.8169 10.4419C14.9342 10.3247 15 10.1658 15 10C15 9.83424 14.9342 9.67527 14.8169 9.55806C14.6997 9.44085 14.5408 9.375 14.375 9.375H10.625V5.625Z"
                                    fill="white"></path>
                            </svg>New Subscription</a> -->

                        
                    </div>

                    <div class="batch-useage-info">
                        Batch usage data is received automatically from the Capture/Imaging system after QA processing. No manual entry is required.
                    </div>


                    <div class="subscriptions-layout ">
                        <div class="subscriptions-table-wrapper table-responsive custom-scroll">
                            <p-table [value]="subscriptions" class="tables subscription-table customers-list-table table-header-fix-two">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Subscription ID</th>
                                        <th>Start</th>
                                        <th>End</th>
                                        <th>Volume</th>
                                        <th>Status</th>
                                        <!-- <th class="action-th">Action</th> -->
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-subscription>
                                    <tr [class.is-selected]="selectedSubscription?.subscriptionId === subscription.subscriptionId"
                                        (click)="selectSubscription(subscription)">
                                        <td>{{ subscription.id }}</td>
                                        <td>{{ subscription.start | date: 'MMM d, y' }}</td>
                                        <td>{{ subscription.end | date: 'MMM d, y' }}</td>
                                        <td>{{ subscription.totalVolume | number }}</td>
                                        <td>
                                            <span class="status-badge" [ngClass]="statusClass(subscription.status)">
                                                {{ subscription.status }}
                                            </span>
                                        </td>
                                        <!-- <td class="text-left">
                                            <div class="table-action">
                                                <a class="edits" href="javascript:void(0);" pTooltip="Edit"
                                                    tooltipPosition="top">
                                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M18.0886 0.863808C17.7995 0.589949 17.4564 0.372711 17.0787 0.224498C16.701 0.0762847 16.2962 0 15.8874 0C15.4786 0 15.0738 0.0762847 14.6962 0.224498C14.3185 0.372711 13.9753 0.589949 13.6863 0.863808L1.98036 11.9534C1.63204 12.2834 1.37872 12.6929 1.24651 13.1428L0.0218525 17.2863C-0.00644283 17.3824 -0.00727457 17.4838 0.0194429 17.5803C0.0461603 17.6768 0.0994663 17.7647 0.173899 17.8353C0.248331 17.9058 0.341214 17.9563 0.44303 17.9816C0.544846 18.0069 0.651935 18.0061 0.753324 17.9793L5.12632 16.8191C5.60126 16.6932 6.03394 16.4535 6.38265 16.1232L18.0886 5.03356C18.6722 4.48057 19 3.73064 19 2.94869C19 2.16673 18.6722 1.4168 18.0886 0.863808V0.863808ZM14.5262 1.65876C14.8873 1.31675 15.3771 1.12465 15.8877 1.12472C16.3983 1.12479 16.888 1.31703 17.249 1.65914C17.6101 2.00125 17.8128 2.46521 17.8128 2.94895C17.8127 3.4327 17.6098 3.8966 17.2487 4.23861L16.0295 5.39279L13.3071 2.81294L14.5262 1.65876V1.65876ZM12.468 3.60865L15.1912 6.18849L5.54273 15.3282C5.33837 15.5218 5.08482 15.6623 4.8065 15.7362L1.44917 16.6264L2.38885 13.4466C2.46693 13.183 2.61522 12.9428 2.8195 12.7491L12.468 3.60865V3.60865Z"
                                                            fill="#484848" />
                                                    </svg>
                                                </a>
                                                <a class="edits" href="javascript:void(0);" pTooltip="Delete"
                                                    tooltipPosition="top">
                                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M9.07821 6.32679e-09C9.89293 -4.92948e-05 10.6768 0.288035 11.269 0.805156C11.8612 1.32228 12.2168 2.02923 12.2629 2.78099L12.2679 2.94789H17.4203C17.6068 2.94794 17.7864 3.01342 17.9226 3.13108C18.0589 3.24875 18.1418 3.40984 18.1545 3.5818C18.1672 3.75376 18.1088 3.92377 17.9911 4.05747C17.8734 4.19117 17.7052 4.27861 17.5205 4.3021L17.4203 4.30845H16.6391L15.3829 16.1181C15.32 16.7069 15.0326 17.2558 14.5722 17.6669C14.1118 18.0779 13.5083 18.3244 12.8695 18.3622L12.6967 18.3676H5.45968C4.81926 18.3676 4.19972 18.1571 3.71177 17.7738C3.22381 17.3904 2.89925 16.8592 2.79609 16.2751L2.77352 16.1172L1.51631 4.30845H0.736071C0.558199 4.30844 0.386347 4.24891 0.252295 4.14086C0.118243 4.03281 0.0310605 3.88355 0.00686997 3.72069L0 3.62817C7.50096e-06 3.46378 0.0644235 3.30495 0.181336 3.18106C0.298248 3.05717 0.459746 2.97659 0.635965 2.95424L0.736071 2.94789H5.88857C5.88857 2.16606 6.22462 1.41625 6.82279 0.863416C7.42097 0.31058 8.23227 6.32679e-09 9.07821 6.32679e-09ZM15.1601 4.30845H2.99532L4.23879 15.9839C4.26632 16.2444 4.39054 16.4881 4.59036 16.6736C4.79018 16.8591 5.05329 16.975 5.33504 17.0016L5.45968 17.007H12.6967C13.2856 17.007 13.7851 16.6215 13.899 16.0982L13.9186 15.9839L15.1591 4.30845H15.1601ZM10.7957 6.80282C10.9736 6.80282 11.1454 6.86236 11.2795 6.97041C11.4135 7.07846 11.5007 7.22772 11.5249 7.39058L11.5318 7.4831V13.8324C11.5317 14.0048 11.4609 14.1707 11.3336 14.2966C11.2062 14.4226 11.0319 14.4991 10.8459 14.5109C10.6598 14.5226 10.4759 14.4687 10.3312 14.3599C10.1865 14.2511 10.0919 14.0957 10.0665 13.9249L10.0596 13.8324V7.4831C10.0596 7.30268 10.1372 7.12964 10.2752 7.00207C10.4133 6.87449 10.6005 6.80282 10.7957 6.80282ZM7.36071 6.80282C7.53858 6.80282 7.71043 6.86236 7.84449 6.97041C7.97854 7.07846 8.06572 7.22772 8.08991 7.39058L8.09678 7.4831V13.8324C8.09673 14.0048 8.02588 14.1707 7.89856 14.2966C7.77124 14.4226 7.59694 14.4991 7.41088 14.5109C7.22482 14.5226 7.04087 14.4687 6.8962 14.3599C6.75153 14.2511 6.65693 14.0957 6.63151 13.9249L6.62464 13.8324V7.4831C6.62464 7.30268 6.70219 7.12964 6.84023 7.00207C6.97827 6.87449 7.16549 6.80282 7.36071 6.80282ZM9.07821 1.36056C8.64718 1.36058 8.23191 1.51038 7.91483 1.78023C7.59776 2.05009 7.40207 2.42026 7.3666 2.81727L7.36071 2.94789H10.7957C10.7957 2.5269 10.6148 2.12316 10.2927 1.82548C9.97057 1.5278 9.53372 1.36056 9.07821 1.36056Z"
                                                            fill="#484848" />
                                                    </svg>
                                                </a>

                                            </div>
                                        </td> -->
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>

                        <aside class="subscription-summary-panel" *ngIf="selectedSubscription">
                            <div class="summary-card">
                                <h2>Viewing usage for <span>{{ selectedSubscription.id }}</span></h2>

                                <div class="usage-data">
                                    <div class="usage-row">
                                        <span>Total Subscription Volume</span>
                                        <strong>{{ selectedSubscription.totalVolume | number }} pages</strong>
                                    </div>
                                    <div class="usage-row">
                                        <span>Current Usage Volume</span>
                                        <strong>{{ selectedSubscription.currentUsage | number }} pages</strong>
                                    </div>
                                    <div class="usage-row">
                                        <span>Remaining Volume</span>
                                        <strong>{{ remainingVolume | number }} pages</strong>
                                    </div>
                                </div>
                                <div class="usage-row">
                                    <span>Status</span>
                                    <span class="status-badge" [ngClass]="statusClass(selectedSubscription.status)">{{ selectedSubscription.status }}</span>
                                </div>

                                <div class="usage-meter">
                                    <div class="usage-meter__label">
                                        <span>Usage Percentage</span>
                                        <strong>{{ usagePercent }}%</strong>
                                    </div>
                                    <div class="usage-meter__track">
                                        <span class="usage-meter__fill" [style.width.%]="usagePercent"></span>
                                    </div>
                                </div>
                            </div>

                        </aside>
                    </div>
                </div>
        </div>
    </div>
</div>


<!-- Delete Popup-->
<p-dialog styleClass="popop" [(visible)]="displayNewSubscriptionDialog" [modal]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">

    <div class="popop-content delete-popop-content">
        <h3>New Subscription</h3>
        <div class="subscription-dialog__content">
            <form class="form" autocomplete="off">
                <div class="form__group">
                    <label class="form__label">Customer</label>
                    <input class="form__control" type="text" [value]="customerName" disabled />
                </div>

                <div class="field-pair">
                    <div class="form__group">
                        <label class="form__label">Start Date</label>
                        <input class="form__control" type="date" [value]="newSubscription.startDate"
                            (input)="newSubscription.startDate = $any($event.target).value" />
                    </div>

                    <div class="form__group">
                        <label class="form__label">End Date</label>
                        <input class="form__control" type="date" [value]="newSubscription.endDate"
                            (input)="newSubscription.endDate = $any($event.target).value" />
                    </div>
                </div>

                <div class="form__group">
                    <label class="form__label">Subscription Volume (Pages)</label>
                    <input class="form__control" type="number" [value]="newSubscription.volume"
                        (input)="newSubscription.volume = +$any($event.target).value" />
                </div>
            </form>
        </div>

        <div class="button-block">
            <button type="button" class="btn-secondary" (click)="closeNewSubscriptionDialog()">Cancel</button>
            <button type="button" class="btn-primary" (click)="createSubscription()">Create Subscription</button>
        </div>
    </div>
</p-dialog>

<!-- Delete Popup-->
<p-dialog styleClass="popop" [(visible)]="SubscriptionDeletePopup" [modal]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">

    <div class="popop-content delete-popop-content">
        <h3>Delete Subscription</h3>
        <p>Are you sure you want to delete this subscription?</p>
        <div class="button-block">
            <button class="btn-secondary" type="button" (click)="closeDeletePopup()">No</button>
            <button class="btn-primary" type="button" (click)="onClickYes()">Yes</button>
        </div>
    </div>
</p-dialog>